import React from "react";
import { motion } from "framer-motion";

import "./Header.scss";

import images from "../../constants/images";
import AppWrap from "../../wrapper/AppWrap/AppWrap";

const Header = () => {
  const cvariant = {
    whileInView: {
      x: [-100, 0],
      opacity: [0, 1],
      transition: {
        duration: 0.9,
        ease: "easeInOut",
      },
    },
  };
  return (
    <div className="app__header">
      <motion.div
        className="app__navbar-info"
        animate={{
          x: [-200, 0],
          opacity: [0, 100],
          transition: { duration: 1 },
        }}
      >
        <div className="app__header-badge">
          <span className="badge-icon">
            👋
            {/* <img src={images.goodbye} alt="Welcome icon" /> */}
          </span>
          <div className="badge-name">
            <p>Hello I'm</p>
            <h1>Karim Muhammad</h1>
          </div>
        </div>

        <div className="app__header-work">
          <h4>Web Developer</h4>
          <h3>Front-End Developer</h3>
          <h3>Back-End Developer</h3>
        </div>
      </motion.div>

      <motion.div
        className="app__navbar-profile"
        whileInView={{ scale: [0, 1], transition: { delayChildren: 0.5 } }}
      >
        <img src={images.Ai_brand3} alt="Profile Image" />
        <motion.img
          className="overlay-circle"
          src={images.circle}
          whileInView={{ scale: [0, 1] }}
        />
      </motion.div>
      <motion.div
        className="circle-skills"
        whileInView={{ scale: [0, 1], opacity: [0, 1] }}
      >
        {[images.cpp, images.javascript, images.python].map((circle, id) => (
          <motion.div
            key={`pop-${circle}`}
            className="circle-skill"
            whileInView={{ scale: [0, 1] }}
          >
            <img key={`circle-${id}`} src={circle} alt="circle-skill" />
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, "home");
